import React from "react";
import PropTypes from "prop-types";
import {
  Highlight,
  HighlightLinkContener,
  Link,
} from "./Hightlight.style";
import { Trans } from "react-i18next";

const HighlightLink = (props) => {
  // Component that only highlights and links the specific part
  const HighlightedLink = ({ children }) => (
    <span style={{ position: "relative", display: "inline-block" }}>
      {/* Background highlight with offset - only for the specific part */}
      <Highlight
        isText={true}
        color={props.color}
        applyPadding={false}
        style={{
          position: "absolute",
          top: "2px",
          left: "-2px",
          zIndex: 0,
          color: "transparent",
          pointerEvents: "none",
          padding: "0px 3px",
          height: "1em",
          display: "inline-block"
        }}
      >
        {children}
      </Highlight>
      {/* Actual clickable link on top - only for the specific part */}
      <Link
        href={props.url}
        style={{
          position: "relative",
          zIndex: 1,
          textDecoration: "none",
          borderBottom: props.showUnderline !== false ? "1px solid currentColor" : "none",
          fontWeight: "bold"
        }}
      >
        {children}
      </Link>
    </span>
  );

  return (
    <HighlightLinkContener $color={props.color}>
      <Trans
        components={[<HighlightedLink key={0} />]}
        i18nKey={props.text}
      />
    </HighlightLinkContener>
  );
};

HighlightLink.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string,
  url: PropTypes.string,
  text: PropTypes.string,
  showUnderline: PropTypes.bool,
};

export default HighlightLink;
